import React from 'react'
import Footer from '../components/footerComponent/footer'
import Payment from '../components/paymentsComponent/paymentComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function PaymentPage() {
    return (
        <Layout>
            <Header/>
            <Payment/>
            <Footer/>
        </Layout>
    );
};